var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiicon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kpiicon3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #0070d8 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m17 0h14c9.4 0 17 7.6 17 17v14c0 9.4-7.6 17-17 17h-14c-9.4 0-17-7.6-17-17v-14c0-9.4 7.6-17 17-17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m31.8 12.2c2 2.1 3.2 4.9 3.2 7.8 0 2.9-1.2 5.7-3.2 7.8-2.1 2-4.9 3.2-7.8 3.2-1.5 0-2.9-0.3-4.3-0.8-1.3-0.6-2.5-1.4-3.6-2.4-1-1-1.8-2.2-2.4-3.6-0.6-1.3-0.8-2.7-0.8-4.2 0-1.5 0.2-2.9 0.8-4.2 0.6-1.4 1.4-2.6 2.4-3.6 1.1-1 2.3-1.8 3.6-2.4 1.4-0.5 2.8-0.8 4.3-0.8 2.9 0 5.7 1.2 7.8 3.2zm-7.4 2q0-0.1-0.2-0.2-0.1-0.1-0.2-0.1-0.2 0-0.3 0.1-0.1 0.1-0.2 0.2l-1.4 3q-0.1 0.1-0.2 0.2-0.1 0-0.2 0l-3.2 0.5q-0.2 0-0.3 0.1-0.1 0.1-0.1 0.3-0.1 0.1 0 0.2 0 0.2 0.1 0.3l2.4 2.3q0.1 0 0.1 0.2 0 0.1 0 0.2l-0.6 3.2q0 0.2 0.1 0.3 0 0.1 0.1 0.2 0.1 0.1 0.3 0.1 0.1 0 0.3 0l2.8-1.6q0.2 0 0.3 0 0.1 0 0.2 0l2.9 1.6q0.1 0 0.3 0 0.1 0 0.3-0.1 0.1-0.1 0.1-0.2 0.1-0.1 0-0.3l-0.4-3.2q-0.1-0.1-0.1-0.2 0-0.1 0.1-0.2l2.4-2.3q0.1-0.1 0.1-0.3 0.1-0.1 0-0.2 0-0.2-0.1-0.3-0.1-0.1-0.3-0.1l-3.2-0.5q-0.2 0-0.3-0.1-0.1 0-0.1-0.1l-1.5-3zm14.5 19.4q0.1 0.3 0.1 0.6 0 0.4-0.2 0.6-0.2 0.3-0.5 0.4-0.3 0.1-0.6 0l-4.1-1.1-1.1 4.1q-0.1 0.3-0.3 0.5-0.3 0.2-0.6 0.3-0.3 0-0.6-0.1-0.3-0.2-0.5-0.5l-3-5.2c3.2-0.9 6-2.9 7.9-5.6zm-21.4 4.8q-0.2 0.3-0.5 0.4-0.3 0.2-0.6 0.1-0.3 0-0.6-0.2-0.2-0.3-0.3-0.6l-1.1-4-4.1 1q-0.3 0.1-0.6 0-0.3-0.1-0.5-0.3-0.2-0.3-0.2-0.6 0-0.3 0.1-0.6l3.5-6.1c1.9 2.8 4.7 4.8 7.9 5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiicon4);
export default __webpack_public_path__ + "static/media/kpiicon4.a6b63938eaf48bf925dd874e3c6e1349.svg";
export { ForwardRef as ReactComponent };